import Login from "./AuthPages/Login";

const publicRoutes = [
  { path: "/login", component: <Login /> },
];

export default publicRoutes;
